import {
	ChangeDetectionStrategy,
	Component,
	contentChild,
	ElementRef,
	HostListener,
	Input,
	Renderer2,
	signal,
	ViewChild,
	ViewEncapsulation
} from '@angular/core';
// import { MatExpansionModule } from '@angular/material/expansion';
import { FormularioBuscadorComponent } from '../formulario-buscador/formulario-buscador.component';

@Component({
	selector: 'app-buscardorhome',
	standalone: true,
	// imports: [MatExpansionModule, FormularioBuscadorComponent],
	imports: [FormularioBuscadorComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './buscardorhome.component.html',
	styleUrl: './buscardorhome.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class BuscardorhomeComponent {
	readonly panelOpenState = signal(true);
	@Input() codigoEcommerceVuelta: number = 0;
	@Input() clasetop!: string;
	@ViewChild('buscardor') miElemento!: ElementRef;
	@ViewChild('buscadortop') miElemento2!: ElementRef;
	fjfjf = contentChild('buscardor');
	constructor(private renderer: Renderer2, private el: ElementRef) {}
	@HostListener('window:scroll', [])
	onWindowScroll() {}
}
